import React, { PureComponent } from 'react';
import LazyLoad from 'react-lazyload'

let Parser = require('./rss/parser');
let parser = new Parser({
  customFields: {
    item: [
      ['media:content', 'media:content', {keepArray: false}],
    ]
  }
});

// Bring in moment to handle dates
var moment = require('moment');

export default class RecentNews extends PureComponent {
  constructor() {
    super()
    this.state = {
      entries: [],
      expanded: true
    }
  }

  componentDidMount(){
    // Default wildfires feed, but allow a custom feed
    let thisFeed = "https://www.sfchronicle.com/default/feed/top-100-2019-recirc-2388.php";
    if (this.props.feed){
      thisFeed = this.props.feed;
      // Don't even allow gate feeds to get loaded here
      if (thisFeed.indexOf("sfgate") != -1){
        thisFeed = thisFeed.replace("sfgate", "sfchronicle");
      }
    }
    // Parse stories out of feed
    parser.parseURL(thisFeed, (err, feed) => {
      if (feed && feed.items){
        this.setState({
          entries: feed.items.slice(0, 20)
        });
      }
    })
  }

  render(){
    // Don't show if we don't have data yet (or if it's been collapsed)
    if (this.state.entries.length === 0 || !this.state.expanded){
      return false;
    } else {
      // Render latest news items
      return (
        <div className="recent-news-wrapper">
          <LazyLoad once>
            <div className="recent-news-title">{this.props.title}</div>
            <div className="recent-items">
              { this.state.entries.map((recentItem, i) => {

                // Swap the high res image out for a small one
                if(recentItem['media:content']){
                  let imgURL = recentItem['media:content']['$']['url'];
                  imgURL = imgURL.replace("rawImage", "gallery_medium");
                  return (
                    <div key={"recent" + i} className="recent-item">
                      <div className="img">
                        <a href={recentItem.link} target="_blank"><img src={imgURL} /></a>
                      </div>
                      <div className="info">
                        <a href={recentItem.link} target="_blank"><h3>{recentItem.title}</h3></a>
                      </div>
                    </div>
                  )
                }else{
                  return (
                    <div key={"recent" + i} className="recent-item">
                      <div className="img">
                      </div>
                      <div className="info">
                        <a href={recentItem.link} target="_blank"><h3>{recentItem.title}</h3></a>
                      </div>
                    </div>
                  )
                }
              })}
            </div>  
          </LazyLoad>
        </div>
      )
    }
  }
};